//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
let d=[[[0,"FilterByAngle",1,0],[0,"FilterByAngleOption",1,0],[0,"FilterByLength",1,0],[0,"FilterByLengthOption",1,0],[0,"FilterByRatioOption",1,0],[0,"FilterByThicknessOption",1,0],[0,"FilterCandidatesOption",1,0],[0,"FilterDanglingRods",1,0],[0,"FilterDownwardRods",1,0],[1,"LatticeBodies",0,"ScCollector",0],[1,"MaximumAngle",0,"Expression",0],[1,"MaximumRodLength",0,"Expression",0],[1,"MaximumRodRatio",0,"Expression",0],[1,"MaximumRodThickness",0,"Expression",0],[1,"MinimumAngle",0,"Expression",0],[1,"MinimumRodLength",0,"Expression",0],[1,"MinimumRodRatio",0,"Expression",0],[1,"MinimumRodThickness",0,"Expression",0],[0,"PrintPlaneNormal",1,"Direction",0]],[],[]];
SPLM.Features.FilterLattice3Builder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.FilterLattice3Builder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.FilterLattice3Builder.FilterCandidatesType = Object.freeze({
    "All" : "All", "Dangling" : "Dangling"});

SPLM.Features.FilterLattice3Builder.FilterDanglingRodsType = Object.freeze({
    "None" : "None", "FirstLevel" : "FirstLevel", "Iterative" : "Iterative"});

SPLM.Features.FilterLattice3Builder.FilterRangeType = Object.freeze({
    "None" : "None", "BelowMinimum" : "BelowMinimum", "AboveMaximum" : "AboveMaximum", "OutsideLimits" : "OutsideLimits"});

export default SPLM;